
















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DsEditor from "@/components/ds-editor/ds-editor.vue";
import PreviewImg from "../../template/components/preview-dialog.vue";
import { getLevelOptions } from "../../template/common";
@Component({
  components: {
    DsEditor,
    PreviewImg,
  },
})
export default class Name extends Vue {
  @Prop()
  private ifCompose: any;
  @Prop()
  private detail: any;
  @Watch("detail", { immediate: true })
  private detailChange() {
    // 处理数据
    this.data = JSON.parse(JSON.stringify(this.detail));
  }
  private data: any = {};
  private colors: any = [
    "#08C664",
    "#ECA12C",
    "#F60D0D",
    "#F541F3",
    "#19DDDB",
    "#94E51A",
    "#0CCDA9",
    "#DFD111",
    "#A911DF",
    "#6D65EE",
  ];
  private previewUrl: any = '';
  private ifShowPreview: any = false;
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private closePreview() {
    this.ifShowPreview = false;
  }
  private preview(url: any) {
    this.previewUrl = url;
    this.ifShowPreview = true;
  }
  private editorChange(e: any) {
    this.data.report.suggest = e;
    this.change();
  }
  private change() {
    this.$emit("changeData", this.data);
  }
  // 舌色和苔色改变
  private change2(e: any, type: any) {
    if (type == "面色") {
      this.data.report["面色唇色参数"][3][0] = e;
      this.$forceUpdate();
    } else if (type == "唇色") {
      this.data.report["面色唇色参数"][3][6] = e;
      this.$forceUpdate();
    }
    this.change();
  }
  private getOption(type: any, key: any, level: any) {
    return getLevelOptions(type, key, level);
  }
  private open(url: any) {
    window.open(url);
  }
  private mounted() { }
}
